// extracted by mini-css-extract-plugin
export var linkText = "_m9-0";